var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',_vm._b({ref:"img",attrs:{"src":_vm.imageUrl,"width":_vm.width,"aspect-ratio":_vm.ar}},'v-img',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }